import { useSelector } from "react-redux";
import { tenantIdSelector } from "@/react/features/customer/customerSlice";
import { useGetTenantAudioFilesQuery } from "@/react/services/api/tenantApi";
import DynamicSelectCell from "@/react/features/smp/cells/DynamicSelectCell";

export const AUDIO_FILE_TYPES = Object.freeze({
  WHISPER: "WHISPER",
  WAITING: "WAITING",
});

const TYPE_TO_INPUT_PROPS = Object.freeze({
  [AUDIO_FILE_TYPES.WHISPER]: {
    testId: "whisper-audio-select",
    placeholder: "Select Whisper Audio",
  },
  [AUDIO_FILE_TYPES.WAITING]: {
    testId: "waiting-audio-select",
    placeholder: "Select Waiting Audio",
  },
});

const WHISPER_DIRECTORY = Object.freeze("User - Agent Whisper");

export const AudioFileCell = (type) => (props) => {
  const tenantName = useSelector(tenantIdSelector);
  const { data, isFetching } = useGetTenantAudioFilesQuery({
    tenantName,
  });

  /**
   * Whisper Audio ID (should be filtered by directory - "User - Agent Whisper")
   * Waiting Audio ID (should be filtered by directory to allow anything but "User - Agent Whisper")
   */

  const options = (data || [])
    .filter((audioFile) =>
      type === AUDIO_FILE_TYPES.WHISPER
        ? audioFile.directory === WHISPER_DIRECTORY
        : audioFile.directory !== WHISPER_DIRECTORY
    )
    .map((audioFile) => ({
      value: audioFile.name,
      label: audioFile.name,
    }));

  return (
    <DynamicSelectCell
      {...props}
      options={options}
      isFetching={isFetching}
      {...TYPE_TO_INPUT_PROPS[type]}
    />
  );
};
